import * as React from "react";

const SVGComponent = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2635 6.8855L10.1685 8.98049L9.50748 8.31946C9.05335 7.86533 8.31295 7.86533 7.85882 8.31946L3.34223 12.8374C3.12232 13.0573 3 13.35 3 13.6623C3 13.9746 3.12101 14.2661 3.34223 14.4873L5.40078 16.5459C5.6285 16.7736 5.92648 16.8868 6.22576 16.8868C6.52505 16.8868 6.82303 16.7736 7.05075 16.5459L11.5686 12.028C12.0241 11.5739 12.0241 10.8335 11.5686 10.3793L10.9076 9.71829L13.0026 7.6233C13.2056 7.42031 13.2056 7.0911 13.0026 6.8868C12.7996 6.68381 12.4691 6.68381 12.2661 6.8868L12.2635 6.8855ZM10.8308 11.2902L6.31295 15.8081C6.2648 15.8562 6.18412 15.8575 6.13598 15.8081L4.07742 13.7495C4.04749 13.7196 4.04099 13.6845 4.04099 13.661C4.04099 13.6376 4.04749 13.6025 4.07742 13.5726L8.59531 9.05466C8.64476 9.00521 8.72414 9.00521 8.77228 9.05466L10.8308 11.1132C10.8803 11.1627 10.8803 11.242 10.8308 11.2902Z"
      fill={props.color || "#4F4F4F"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.49515 10.1437C7.80029 10.1437 7.23425 10.7098 7.23425 11.4046C7.23425 12.0995 7.80029 12.6655 8.49515 12.6655C9.19001 12.6655 9.75605 12.0995 9.75605 11.4046C9.75605 10.7098 9.19001 10.1437 8.49515 10.1437ZM8.49515 11.6258C8.37414 11.6258 8.27524 11.527 8.27524 11.4059C8.27524 11.2849 8.37414 11.186 8.49515 11.186C8.61617 11.186 8.71506 11.2849 8.71506 11.4059C8.71506 11.527 8.61617 11.6258 8.49515 11.6258Z"
      fill={props.color || "#4F4F4F"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7508 5.48541C13.3995 5.48541 13.1145 5.77038 13.1145 6.12172C13.1145 6.47305 13.3995 6.75802 13.7508 6.75802C14.1021 6.75802 14.3871 6.47305 14.3871 6.12172C14.3871 5.77038 14.1021 5.48541 13.7508 5.48541Z"
      fill={props.color || "#4F4F4F"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3396 5.01041C13.6272 5.01041 13.8601 4.77749 13.8601 4.48992V3.52049C13.8601 3.23292 13.6272 3 13.3396 3C13.0521 3 12.8192 3.23292 12.8192 3.52049V4.48992C12.8192 4.77749 13.0521 5.01041 13.3396 5.01041Z"
      fill={props.color || "#4F4F4F"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.4795 5.60248H15.5101C15.2225 5.60248 14.9896 5.8354 14.9896 6.12297C14.9896 6.41055 15.2225 6.64347 15.5101 6.64347H16.4795C16.7671 6.64347 17 6.41055 17 6.12297C17 5.8354 16.7671 5.60248 16.4795 5.60248Z"
      fill={props.color || "#4F4F4F"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9154 5.33044C15.0481 5.33044 15.1821 5.27969 15.2836 5.17819L15.9694 4.49244C16.1724 4.28945 16.1724 3.96024 15.9694 3.75594C15.7664 3.55295 15.4359 3.55295 15.2329 3.75594L14.5471 4.44169C14.3441 4.64469 14.3441 4.9739 14.5471 5.17819C14.6486 5.27969 14.7814 5.33044 14.9154 5.33044Z"
      fill={props.color || "#4F4F4F"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5101 5.66367C11.6116 5.76516 11.7443 5.81591 11.8784 5.81591C12.0124 5.81591 12.1451 5.76516 12.2466 5.66367C12.4496 5.46068 12.4496 5.13146 12.2466 4.92717L11.5609 4.24142C11.3579 4.03842 11.0287 4.03842 10.8244 4.24142C10.6214 4.44441 10.6214 4.77362 10.8244 4.97792L11.5101 5.66367Z"
      fill={props.color || "#4F4F4F"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1497 7.29153C14.9467 7.08853 14.6175 7.08853 14.4132 7.29153C14.2102 7.49452 14.2102 7.82373 14.4132 8.02803L15.0989 8.71378C15.2004 8.81527 15.3331 8.86602 15.4672 8.86602C15.6012 8.86602 15.7339 8.81527 15.8354 8.71378C16.0384 8.51078 16.0384 8.18157 15.8354 7.97728L15.1497 7.29153Z"
      fill={props.color || "#4F4F4F"}
    />
  </svg>
);

export default SVGComponent;
